'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Voicemail = function Voicemail(props) {
  var color = props.color,
      size = props.size,
      otherProps = _objectWithoutProperties(props, ['color', 'size']);

  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: size,
      height: size,
      viewBox: '0 0 24 24'
    }, otherProps),
    _react2.default.createElement('circle', {
      cx: '5.5',
      cy: '11.5',
      r: '4.5',
      fill: 'none',
      stroke: color,
      strokeMiterlimit: '10',
      strokeWidth: '2'
    }),
    _react2.default.createElement('circle', {
      cx: '18.5',
      cy: '11.5',
      r: '4.5',
      fill: 'none',
      stroke: color,
      strokeMiterlimit: '10',
      strokeWidth: '2'
    }),
    _react2.default.createElement('line', {
      x1: '5.5',
      y1: '16',
      x2: '18.5',
      y2: '16',
      fill: 'none',
      stroke: color,
      strokeMiterlimit: '10',
      strokeWidth: '2'
    })
  );
};

Voicemail.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Voicemail.defaultProps = {
  color: 'currentColor',
  size: '24'
};

exports.default = Voicemail;


//////////////////
// WEBPACK FOOTER
// ./~/react-feather/dist/icons/voicemail.js
// module id = ./node_modules/react-feather/dist/icons/voicemail.js
// module chunks = 168707334958949